document.addEventListener('turbo:load', function() {
  accordion();

  const burger = document.querySelector('.burger-menu');
  const nav = document.querySelector('.navbar-container');
  const body = document.querySelector('html');

  // Layouts without the marketing navbar (Meerkeep app/auth/landing) have nothing to wire up.
  if (nav == null) return;

  if (nav.classList.contains('nav--open')) {
    body.style.overflow = 'hidden';
  } else {
    body.style.overflow = 'auto';
  }

  function toggleNav() {
    burger.classList.toggle('open');
    nav.classList.toggle('nav--open');
  }

  if (burger != null) {
    burger.addEventListener('click', function() {
      toggleNav();

      if (body.style.overflow === 'hidden') {
        body.style.overflow = 'auto';
      } else {
        body.style.overflow = 'hidden';
      }
    });
  }

  window.addEventListener('resize', function() {
    body.style.overflow = 'auto';

    if (window.innerWidth <= 1200 && nav != null) {
      nav.classList.remove('nav--open');
      burger.classList.remove('open');
    }
  });

});

/* ACCORDION */
function accordion() {
  const dropdown = document.querySelector('.dropdown-button');
  const dropdownContent = document.querySelector('.dropdown-content');

  if (dropdown != null) {
    dropdown.addEventListener('click', function() {
      this.classList.toggle('active-dropdown');
      dropdownContent.classList.toggle('dropdown-content-active');
      // setDropdownContentHeight(dropdownContent);
    });
  }
}

// function setDropdownContentHeight(dropdownContent) {
//   if (dropdownContent.classList.contains('dropdown-content-active')) {
//     let contentHeight = 0;
//     for (const item of dropdownContent.children) {
//       contentHeight += item.offsetHeight;
//     }
//     dropdownContent.style.height = contentHeight + 'px';
//   } else {
//     dropdownContent.style.height = 0;
//   }
// }
